import { initCheckoutPage } from './checkoutPage/data/sagas';
import CheckoutPage from './checkoutPage/entry';
import CheckoutSuccessPage from './checkoutSuccessPage/entry';
import { initDigiQuotePage } from './digiQuotePage/data/sagas';
import DigiQuotePage from './digiQuotePage/entry';

/* eslint-disable require-yield */
// $FlowFixMe
export function* initCheckoutSuccessPage({ match }) {
  const { token } = match.params;
  return {
    token,
  };
}
/* eslint-enable require-yield */

export const digiQuoteRoutes = [
  {
    exact: true,
    path: '/:supplier/quotes/:token',
    component: DigiQuotePage,
    saga: initDigiQuotePage,
  },
  {
    exact: true,
    path: '/checkout',
    component: CheckoutPage,
    saga: initCheckoutPage,
  },
  {
    exact: true,
    path: '/success/:token',
    name: 'success',
    component: CheckoutSuccessPage,
    saga: initCheckoutSuccessPage,
  },
];

export default [
  {
    exact: true,
    path: '/digi_quote/:token',
    component: DigiQuotePage,
    saga: initDigiQuotePage,
  },
  {
    exact: true,
    path: '/checkout',
    component: CheckoutPage,
    saga: initCheckoutPage,
  },
  {
    exact: true,
    path: '/success/:token',
    name: 'success',
    component: CheckoutSuccessPage,
    saga: initCheckoutSuccessPage,
  },
];
